/* eslint-disable import/no-named-as-default */
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";
import utils from "../../universal/utils";

import { SHARED_LEGAL_LINKS } from "../public-site/siteData";
import {
  DEFAULT_DISCORD_INVITE_URL,
  fetchPublicDiscordInviteUrl,
} from "../public-site/discordInviteUrl";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: "auto",
    backgroundColor: "#0a0a0a",
    borderTop: "1px solid rgba(255, 255, 255, 0.08)",
    paddingTop: theme.spacing(2.25),
    paddingBottom: theme.spacing(2.25),
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2),
  },
  inner: {
    maxWidth: 720,
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
  },
  links: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    columnGap: theme.spacing(0.75),
    rowGap: theme.spacing(1),
  },
  link: {
    fontSize: "0.8125rem",
    fontWeight: 400,
    letterSpacing: "0.01em",
    lineHeight: 1.5,
    textDecoration: "none",
    color: "rgba(255, 255, 255, 0.62)",
    transition: "color 0.15s ease-in-out",
    padding: theme.spacing(0.25, 0.5),
    "&:hover": {
      color: "rgba(255, 255, 255, 0.92)",
    },
  },
  sep: {
    fontSize: "0.7rem",
    color: "rgba(255, 255, 255, 0.22)",
    userSelect: "none",
    lineHeight: 1,
    paddingLeft: theme.spacing(0.25),
    paddingRight: theme.spacing(0.25),
    display: "none",
    "@media (min-width: 480px)": {
      display: "inline",
    },
  },
  tagline: {
    marginTop: theme.spacing(1.25),
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: 1.5,
    color: "rgba(255, 255, 255, 0.38)",
    letterSpacing: "0.02em",
  },
});

function CatalogFooter({ classes }) {
  const [discordInviteUrl, setDiscordInviteUrl] = React.useState(
    DEFAULT_DISCORD_INVITE_URL
  );

  React.useEffect(() => {
    let cancelled = false;

    fetchPublicDiscordInviteUrl(utils.getEdgeBasePath())
      .then((resolvedUrl) => {
        if (!cancelled) {
          setDiscordInviteUrl(resolvedUrl);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <footer className={classes.root}>
      <div className={classes.inner}>
        <nav className={classes.links} aria-label="Legal and company">
          {SHARED_LEGAL_LINKS.map((item, index) => (
            <React.Fragment key={item.to}>
              {index > 0 ? (
                <span className={classes.sep} aria-hidden>
                  ·
                </span>
              ) : null}
              <Typography
                component={Link}
                to={item.to}
                className={classes.link}
              >
                {item.label}
              </Typography>
            </React.Fragment>
          ))}
        </nav>
        <Typography
          component="a"
          href={discordInviteUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.link}
          style={{ display: "block", marginTop: 10 }}
        >
          Join our Discord
        </Typography>
        <Typography component="p" className={classes.tagline}>
          Ouro — serious CS2 matchmaking
        </Typography>
      </div>
    </footer>
  );
}

CatalogFooter.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(CatalogFooter);
